<template>
  <div class="box13">
    <pageTitle title="就业领域广" text="社会转型升级加速，催生大量AI职业" />

    <div class="top-box">
      <div class="title">
        <img src="../../../assets/coursePage/ai/box13/icon.png" alt />
        <p>三大主流就业方向</p>
        <img src="../../../assets/coursePage/ai/box13/icon.png" alt />
      </div>

      <div class="text-box">
        <p>
          图像与视觉
          <br />处理CV
        </p>
        <p>
          自然语言
          <br />处理NLP
        </p>

        <p>
          数据科学
          <br />
          <span>数据挖掘，数据分析</span>
        </p>
      </div>
    </div>

    <div class="img-box">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <img
      class="block"
      src="../../../assets/coursePage/ai/box13/block.png"
      alt
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box13/bg.png") no-repeat;
  background-size: cover;
  text-align: center;

  .top-box {
    margin: 0 auto;
    margin-top: 48px;

    width: 686px;
    height: 260px;
    background-color: rgba(255, 255, 255, 0.5);
    background-image: url("../../../assets/coursePage/ai/box13/ai.png");
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;
    background-size: (388px, 164px);
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    border: 2px solid #ffffff;

    .title {
      margin-top: 32px;
      margin-bottom: 34px;
      display: flex;
      justify-content: center;
      img {
        width: 40px;
        height: 40px;
      }
      p {
        margin: 0px 16px;
        font-size: 28px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #4e5969;
        line-height: 44px;
        background: linear-gradient(270deg, #65adff 0%, #1fd7cd 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .text-box {
      display: flex;

      p {
        position: relative;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #1d2129;
        line-height: 52px;
        span {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
        }
        &:nth-child(1) {
          margin-left: 46px;
          margin-right: 75px;
        }
        &:nth-child(2) {
          margin-right: 48px;
        }
      }
    }
  }

  .img-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 116px;
    padding-right: 168px;
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    div {
      width: 36px;
      height: 52px;
      background: url("../../../assets/coursePage/ai/box13/arrow.png") no-repeat;
      background-size: cover;
    }
  }

  .block {
    width: 678px;
    height: 464px;
  }
}
</style>
